var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('navbar',{attrs:{"text":`${_vm.$t('LeftPanel_title_ParcelSystem')} > ${_vm.actualUser.name} > ${_vm.$t('DxViewClient_detail_Client')}`}}),_vm._v(" "),_c('DxSystemParcelViewClient')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }